var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-detail-item"},[_c('form-editor',{ref:"Form",attrs:{"data":_vm.data,"model":_vm.formModel},on:{"updateModelItem":_vm.handlerUpdateModelItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }